import { motion, AnimatePresence } from 'framer-motion';
import { observer } from "mobx-react";
import studioStore from '@/stores/studioStore';

const QuantityIndicator = observer(({
  inCart,
}) => {

  return (
    <AnimatePresence initial mode="wait">
      {inCart > 0 && (
        <motion.div
          key="quantity-indicator"
          className="quantity-indicator h-6 w-6 md:h-8 md:w-8 p-1 text-sm md:text-base text-center rounded-full text-white flex items-center justify-center cursor-pointer"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0 }}
          transition={{ duration: 0.2 }}
          style={{ backgroundColor: studioStore?.settings?.colors?.primary_color }}
          whileHover={{
            backgroundColor: studioStore?.settings?.colors?.error_color,
          }}
        >
          <motion.div
            key="content"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
              transition={{ duration: 0.1 }}
            >
              {inCart}
            </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default QuantityIndicator;
